import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mob-sidebar"
export default class extends Controller {
  connect() {
  }
  toggle(){
    this.element.classList.toggle('open');
  }
}
